import { isAbsoluteUrlString } from './isAbsoluteUrlString'
import { isRelativeUrlString, type RelativeUrlStringBrand } from './isRelativeUrlString'

export type RelativeOrAbsoluteUrlStringBrand = RelativeUrlStringBrand

export function isRelativeOrAbsoluteUrlString(input: any): input is RelativeOrAbsoluteUrlStringBrand {
  return isRelativeUrlString(input) || isAbsoluteUrlString(input)
}
